// Environment detection
function detectEnvironment(): 'dev' | 'uat' | 'prod' {
  const hostname = window.location.hostname

  if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
    return 'dev'
  }
  if (hostname.includes('-uat')) {
    return 'uat'
  }
  if (hostname.includes('-prod') || !hostname.includes('-dev')) {
    return 'prod'
  }
  return 'dev'
}

// API base URL based on environment
function getApiBaseUrl(): string {
  // Allow override via environment variable (set at build time)
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL
  }

  const env = detectEnvironment()

  // Fallback URLs using consistent -cm-backend naming
  switch (env) {
    case 'dev':
      return 'https://app-foundaai-dev-cm-backend.azurewebsites.net/api'
    case 'uat':
      return 'https://app-foundaai-uat-cm-backend.azurewebsites.net/api'
    case 'prod':
      return 'https://app-foundaai-prod-cm-backend.azurewebsites.net/api'
    default:
      return 'http://localhost:8765/api'
  }
}

// Configuration object
export const config = {
  env: detectEnvironment(),
  api: {
    baseUrl: getApiBaseUrl(),
    timeout: 120000, // 2 minutes
  },
} as const

export type Environment = 'dev' | 'uat' | 'prod'
